import { GET } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取服务记录列表
 */
export const fetchServiceList = async (params) => {
    const res = await GET(APIs.API_SERVICE_SERVICELIST, {
        params,
    });

    return res.data.data ?? {};
};
